import React, { Component } from 'react';

import '../css/main.scss';

import { Link } from 'react-router-dom';
import { PrjListCmp } from '../component';

import AOS from 'aos';
import 'aos/dist/aos.css';

// image import
import img1 from '../images/work/ph_g01.jpg';
import img2 from '../images/work/ph_g02.jpg';
import img3 from '../images/work/ph_g03.jpg';
import img4 from '../images/work/ph_g04.jpg';
import img5 from '../images/work/ph_g05.jpg';
import img6 from '../images/work/ph_g06.jpg';

import prjList from '../projects/projectData.json';

import mainVideo from '../video/magic.mp4';
import videoCover from '../video/cover.jpg';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listData: [
        {
          type: prjList[1].type,
          title: prjList[1].title,
          img: img1,
        },
        {
          type: prjList[2].type,
          title: prjList[2].title,
          img: img2,
        },
        {
          type: prjList[3].type,
          title: prjList[3].title,
          img: img3,
        },
        {
          type: prjList[4].type,
          title: prjList[4].title,
          img: img4,
        },
        {
          type: prjList[5].type,
          title: prjList[5].title,
          img: img5,
        },
        {
          type: prjList[6].type,
          title: prjList[6].title,
          img: img6,
        },
      ],
      isLoaded: false,
      filterOpen: true,
      isMobile: false,
    };
  }

  componentDidMount() {
    window.scrollTo({ top: 0 });

    AOS.init();
  }

  componentWillUnmount() {}

  render() {
    return (
      <React.Fragment>
        <div className="main">
          <div className="chinamagic" data-aos="fade-up">
            <span
              className="code"
              data-aos="fade-left"
              data-aos-delay="300"
              data-aos-duration="1000"
            >
              China
            </span>
            <span
              className="design"
              data-aos="fade-right"
              data-aos-delay="600"
              data-aos-duration="1000"
            >
              Magic
            </span>
          </div>

          <div className="main_copy">
            {/* <p className="m_copy random_text" data-text="Magic &amp; 变脸" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease">
              Magic &amp; 变脸 <span className="mbr"></span>
            </p> */}

            <p
              className="s_copy "
              data-aos="fade-right"
              data-aos-delay="600"
              data-aos-duration="1000"
              data-aos-easing="ease"
            >
              <strong>变脸 </strong> 오리지널 중국 변검 마술공연 <br />
              변검 브랜드파워 1위 차이나매직
              {/* 국내 유일 변검 마술쇼, <span className="wbr"></span> 우수한 퍼포먼스와 풍부한 경험으로 
                새로운 감동을 선사합니다. */}
            </p>
          </div>

          <div className="video_wrap">
            <video
              id="mainVideo"
              autoPlay
              playsInline
              muted
              loop
              poster={videoCover}
            >
              <source src={mainVideo} type="video/mp4" />
            </video>
          </div>

          <div className="btn_wrap">
            <Link to="/About" className="btn action">
              차이나매직 소개
            </Link>
          </div>

          <div className="section_copy" data-aos="fade-up">
            <p className="cate">Our Performance</p>
            <p className="desc">변검과 마술이 어우러진 환상적인 퍼포먼스</p>
          </div>

          <div className="item_wrap colbox col3">
            {/* PrjListCmp 맵핑 */}
            {prjList.slice(0, 6).map((list, i) => {
              return (
                <PrjListCmp
                  type={list.type}
                  title={list.title}
                  img={list.src}
                  idx={i}
                  key={i}
                  onCreate={this.handleCreate}
                />
              );
            })}
          </div>

          <div className="btn_wrap">
            <Link to="/Work" className="btn action">
              공연사진 보러가기
            </Link>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Home;
